import script from "./ValidationTypeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ValidationTypeModal.vue?vue&type=script&setup=true&lang=js"

import "./ValidationTypeModal.vue?vue&type=style&index=0&id=4c07d823&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c07d823"]])

export default __exports__